import {TopicModel} from '@/models/topic.model';
import {BaseApi, RequireAuthApi} from '@/api/base.api';

export class ChallengeForumApi extends BaseApi<TopicModel> {
  constructor(public challengeId: number) {
    super(`challenges/${challengeId}/forum/topics`, [
      RequireAuthApi.CREATE,
      RequireAuthApi.UPDATE,
      RequireAuthApi.DESTROY,
    ]);
  }
}

